'use client';

import {Icon} from '@components/@icons';
import {MeinText} from '@components/@typography/MeinText';
import {Easing} from '@config/easing';
import classNames from 'classnames';
import {motion} from 'framer-motion';
import {FC, PropsWithChildren, useState} from 'react';
import styles from './MeinCollapseWithToggler.module.css';

interface IProps extends PropsWithChildren {
    label: string;
    defaultState?: boolean;
    containerClassName?: string;
    togglerClassName?: string;
}

export const MeinCollapseWithToggler: FC<IProps> = ({
    children,
    defaultState = false,
    label,
    containerClassName,
    togglerClassName,
}) => {
    const [isOpen, setIsOpen] = useState(defaultState);

    const toggleCollapse = () => {
        setIsOpen(o => !o);
    };

    return (
        <>
            <button
                type="button"
                onClick={toggleCollapse}
                className={classNames(styles.collapseToggle, togglerClassName)}
            >
                <MeinText tag="span">{label}</MeinText>
                <Icon
                    name={isOpen ? 'chevron-up' : 'chevron-down'}
                    size={22}
                    className={styles.chevron}
                />
            </button>
            <motion.div
                initial={
                    defaultState
                        ? {height: 'auto', opacity: 1}
                        : {
                              height: 0,
                              opacity: 0,
                          }
                }
                animate={
                    isOpen
                        ? {
                              height: 'auto',
                              opacity: 1,
                          }
                        : {
                              height: 0,
                              opacity: 0,
                          }
                }
                transition={{duration: 0.3, ease: Easing.bezier.outNormal}}
                className={classNames(styles.container, containerClassName)}
            >
                {children}
            </motion.div>
        </>
    );
};
